import Product from "./Product";
import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
// import { formatWithOptions } from 'date-fns/fp'
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { replaceUrlParam } from "../common/utils";

import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import {
  priceCalculator,
  resetProduct,
  selectProducts,
  fetchProductByID,
} from "../features/products/productsSlice";

import {
  fetchBrands,
  selectBrands,
  getFullList as getFullBrandsList,
} from "../features/brands/brandsSlice";
import {
  fetchSuppliers,
  selectSuppliers,
  getFullList as getFullSuppliersList,
} from "../features/suppliers/suppliersSlice";
import {
  fetchClients,
  selectClients,
  getFullList as getFullClientsList,
} from "../features/clients/clientsSlice";
import {
  selectCategories,
  fetchCategoriesTree,
} from "../features/categories/categoriesSlice";

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
}));

export default function ProductContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();
  const classes = useStyles();

  const location = useLocation();

  const edit = location.pathname.includes("edit");
  const {} = useSelector(selectProducts);

  const { products, error, loading, product } = useSelector(selectProducts);
  let editCats = [];
  let editNames = [];

  let statuses = ["active", "inactive", "deleted", "", "pending"];

  const [code, setCode] = useState(edit ? product.sku : "");
  const [name, setName] = useState(edit ? product.name : "");
  const [shortDesc, setShortDesc] = useState(
    edit ? product.shortDescription : ""
  );
  const [sellingPrice, setSellingPrice] = useState(
    edit ? (product.sellingPrice / 100).toFixed(2).toString() : ""
  );
  const [rrp, setRRP] = useState(
    edit ? (product.rrp / 100).toFixed(2).toString() : ""
  );

  const [freight, setFreight] = useState(
    edit ? (product.freight / 100).toFixed(2).toString() : ""
  );
  const [costPrice, setCostPrice] = useState(
    edit ? (product.costPrice / 100).toFixed(2).toString() : ""
  );
  const [margin, setMargin] = useState(
    edit ? (product.margin * 100).toFixed(2).toString() : ""
  );

  const [productStatus, setProductStatus] = useState(
    edit ? statuses[product.statusID - 1] : ""
  );
  const [productSupplier, setProductSupplier] = useState(
    edit ? product.supplierName : ""
  );
  const [selectedBrand, setBrand] = useState(edit ? product.brandName : "");
  const [editorValue, setEditorValue] = useState(
    edit ? product.longDescription : ""
  );

  const [checked, setCategoriesChecked] = useState(editCats);
  const [names, setNames] = useState(editNames);
  const [excludedClients, setExcludedClients] = useState(
    edit
      ? product.excludedClients &&
          product.excludedClients.map((client) => client.name)
      : []
  );

  const [brandIDs, setBrandIDs] = useState(edit ? product.brandID : "");
  const [supplierIDs, setSupplierIDs] = useState(
    edit ? product.supplierID : ""
  );

  const [featured, setFeatured] = useState(edit ? product.featured : false);
  const [special, setSpecial] = useState(edit ? product.special : false);
  const [specialSellingPrice, setSpecialSellingPrice] = useState(
    edit ? product.specialSellingPrice : ""
  );
  const [specialOfferDescription, setSpecialOfferDescription] = useState(
    edit ? product.specialOfferDescription : ""
  );
  const [specialEndDate, setSpecialEndDate] = useState(
    edit ? product.specialEndDate : ""
  );
  const [images, setImages] = useState(
    edit && product.images ? product.images : []
  );

  const [statusIDs, setStatusIDs] = useState(edit ? product.statusID : "");
  const [statusList, setStatusList] = useState([
    { id: 1, value: "active" },
    { id: 2, value: "inactive" },
    { id: 3, value: "deleted" },
    { id: 5, value: "pending" },
  ]);

  useEffect(() => {
    if (location.pathname.includes("/edit") && !product.id) {
      dispatch(
        fetchProductByID({
          token: jwtToken,
          id: location.pathname.split("/").reverse()[0],
        })
      );
    }
  }, []);

  const [localization, setLocalization] = useState([]);
  useEffect(() => {
    if (location.pathname.includes("new")) {
      console.log("Firing useEffect");
      setCode("");
      setName("");
      setShortDesc("");
      setSellingPrice("");

      setRRP("");
      setFreight("");
      setCostPrice("");
      setMargin("");
      setProductStatus("");
      setProductSupplier("");
      setBrand("");
      setEditorValue("");
      setCategoriesChecked([]);
      setNames([]);
      setBrandIDs("");
      setSupplierIDs("");
      setStatusIDs("");
      setLocalization([]);
      setImages([]);
      setSpecial(false);
      setSpecialEndDate("");
      setSpecialSellingPrice(edit ? product.specialSellingPrice : "");
      setSpecialOfferDescription(edit ? product.specialOfferDescription : "");

      setExcludedClients([]);
      dispatch(resetProduct());
    }
  }, [dispatch, location]);

  useEffect(() => {
    if (edit) {
      console.log('Firing edit state set');
      if (product.categories) {
        editCats = [];
        product.categories.forEach((cat) => {
          editCats.push(cat.id);
          editNames.push(cat.name);
        });
      }
      setCode(product.sku);
      setName(product.name);
      setShortDesc(product.shortDescription);
      setSellingPrice((product.sellingPrice / 100).toFixed(2).toString());

      setRRP((product.rrp / 100).toFixed(2).toString());
      setFreight((product.freight / 100).toFixed(2).toString());
      setCostPrice((product.costPrice / 100).toFixed(2).toString());
      setMargin((product.margin * 100).toFixed(4).toString());
      setProductStatus(statuses[product.statusID - 1]);
      setProductSupplier(product.supplierName);
      setBrand(product.brandName);
      setEditorValue(product.longDescription);
      setCategoriesChecked(editCats);
      setNames(editNames);
      setBrandIDs(product.brandID);
      setSupplierIDs(product.supplierID);
      setStatusIDs(product.statusID);
      setLocalization(product.l10nID);
      setImages(product.images ? product.images : []);
      setFeatured(product.featured);
      setSpecial(product.special ? product.special : false);
      setSpecialEndDate(product.specialEndDate);
      setSpecialSellingPrice(
        product.specialSellingPrice
          ? (product.specialSellingPrice / 100).toFixed(2).toString()
          : ""
      );
      setSpecialOfferDescription(
        product.specialOfferDescription ? product.specialOfferDescription : ""
      );
      setExcludedClients(
        product.excludedClients
          ? product.excludedClients.map((client) => client.name)
          : []
      );
    }
  }, [product]);

  const { brandsList, brandsAmount } = useSelector(selectBrands);
  const { suppliersList, suppliersAmount } = useSelector(selectSuppliers);
  const { clientsList, clientsAmount } = useSelector(selectClients);
  const { categoriesTree } = useSelector(selectCategories);

  const firstUpdateSupplier = useRef(true);

  useEffect(() => {
    if (!suppliersList.length) {
      dispatch(
        fetchSuppliers({
          token: jwtToken,
          query: `?limit=100`,
        })
      );
    }
  }, []);

  useEffect(() => {
    if (
      suppliersList.length &&
      suppliersList.length != suppliersAmount &&
      firstUpdateSupplier.current
    ) {
      let searchQuery = "?limit=100";
      searchQuery = replaceUrlParam(searchQuery, "limit", 100);
      dispatch(
        getFullSuppliersList({
          token: jwtToken,
          offset: suppliersList.length,
          query: searchQuery,
          targetLength: suppliersAmount,
        })
      );
      firstUpdateSupplier.current = false;
    }
  }, [suppliersList.length]);

  const firstUpdateBrand = useRef(true);

  useEffect(() => {
    if (!brandsList.length) {
      dispatch(
        fetchBrands({
          token: jwtToken,
          query: `?limit=100`,
        })
      );
    }
  }, []);

  useEffect(() => {
    if (
      brandsList.length &&
      brandsList.length != brandsAmount &&
      firstUpdateBrand.current
    ) {
      let searchQuery = "?limit=100";
      searchQuery = replaceUrlParam(searchQuery, "limit", 100);
      dispatch(
        getFullBrandsList({
          token: jwtToken,
          offset: brandsList.length,
          query: searchQuery,
          targetLength: brandsAmount,
        })
      );
      firstUpdateBrand.current = false;
    }
  }, [brandsList.length]);

  useEffect(() => {
    if (!clientsList.length) {
      dispatch(fetchClients({ token: jwtToken, query: "" }));
    }

    dispatch(
      fetchCategoriesTree({
        token: jwtToken,
      })
    );
  }, [dispatch]);

  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (
      (suppliersList.length == suppliersAmount,
      brandsList.length == brandsAmount,
      categoriesTree.length,
      clientsList.length)
    ) {
      setReady(true);
    }
  }, [suppliersList, brandsList, categoriesTree, clientsList, product]);

  const handlePriceCalculation = (priceCalc) => {
    console.log("what comes in", priceCalc);

    setRRP((priceCalc.rrp / 100).toFixed(2).toString());
    setFreight((priceCalc.freight / 100).toFixed(2).toString());
    setCostPrice((priceCalc.costPrice / 100).toFixed(2).toString());
    setMargin((priceCalc.margin * 100).toFixed(4).toString());
  };
  let firstLoad = true;

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (ready) {
    content = (
      <Product
        error={error}
        loading={loading}
        product={product}
        products={products}
        brandsList={brandsList}
        suppliersList={suppliersList}
        clientsList={clientsList}
        categoriesTree={categoriesTree}
        edit={edit}
        handlePriceCalculation={handlePriceCalculation}
        code={code}
        setCode={setCode}
        name={name}
        setName={setName}
        shortDesc={shortDesc}
        setShortDesc={setShortDesc}
        statuses={statuses}
        sellingPrice={sellingPrice}
        setSellingPrice={setSellingPrice}
        // menuPosition={menuPosition}
        // setMenuPosition={setMenuPosition}
        rrp={rrp}
        setRRP={setRRP}
        freight={freight}
        setFreight={setFreight}
        costPrice={costPrice}
        setCostPrice={setCostPrice}
        margin={margin}
        setMargin={setMargin}
        productStatus={productStatus}
        setProductStatus={setProductStatus}
        productSupplier={productSupplier}
        setProductSupplier={setProductSupplier}
        selectedBrand={selectedBrand}
        setBrand={setBrand}
        editorValue={editorValue}
        setEditorValue={setEditorValue}
        checked={checked}
        setCategoriesChecked={setCategoriesChecked}
        names={names}
        setNames={setNames}
        excludedClients={excludedClients === null ? [] : excludedClients}
        setExcludedClients={setExcludedClients}
        brandIDs={brandIDs}
        setBrandIDs={setBrandIDs}
        supplierIDs={supplierIDs}
        setSupplierIDs={setSupplierIDs}
        statusIDs={statusIDs}
        setStatusIDs={setStatusIDs}
        statusList={statusList}
        setStatusList={setStatusList}
        featured={featured}
        special={special}
        specialSellingPrice={specialSellingPrice}
        specialOfferDescription={specialOfferDescription}
        specialEndDate={specialEndDate}
        setSpecial={setSpecial}
        setSpecialSellingPrice={setSpecialSellingPrice}
        setSpecialOfferDescription={setSpecialOfferDescription}
        setSpecialEndDate={setSpecialEndDate}
        setFeatured={setFeatured}
        images={images}
        setImages={setImages}
        setLocalization={setLocalization}
        localization={localization}
        firstLoad={firstLoad}
      />
    );
  }
  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      {content}
    </Grid>
  );
}
